import React, { useState } from "react";
import "./HaversineCalculator.css"; // Add styles

const toRadians = (degrees) => (degrees * Math.PI) / 180;

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of Earth in KM

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in KM
};

const HaversineCalculator = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [distance, setDistance] = useState(null);

  const handleCalculate = () => {
    if (!point1 || !point2) {
      alert("Please enter both points.");
      return;
    }

    let [lat1, lon1] = cleanNumberInput(point1).split(/[, ]+/).map(Number);
    let [lat2, lon2] = cleanNumberInput(point2).split(/[, ]+/).map(Number);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      alert("Invalid coordinates! Please enter valid latitude and longitude.");
      return;
    }

    const dist = haversineDistance(lat1, lon1, lat2, lon2);
    setDistance(dist.toFixed(2));
  };

  const cleanNumberInput= (input) => {
    return input.replace(/[^0-9.,]/g, '');
}

  return (
    <div className="calculator-card">
     <h2>Haversine Distance Calculator</h2>
      <input type="text" placeholder="Enter Point 1 (lat, long)" value={point1} onChange={(e) => setPoint1(e.target.value)} />
      <input type="text" placeholder="Enter Point 2 (lat, long)" value={point2} onChange={(e) => setPoint2(e.target.value)} />
      <button onClick={handleCalculate}>Calculate Distance</button>
      {distance && <p>Distance: {distance} meters</p>}
            {/* Information Section */}
            <div className="info-section">
        <h3>What is the Haversine Formula?</h3>
        <p>
          The Haversine formula is used to calculate the shortest distance between two points 
          on a sphere, making it ideal for **finding distances between two geographic coordinates**.
          It assumes the Earth is a perfect sphere, which makes it slightly less accurate than 
          Vincenty’s formula.
        </p>
        <a href="https://en.wikipedia.org/wiki/Haversine_formula" target="_blank" rel="noopener noreferrer">
    Learn more on Wikipedia
  </a>
      </div>
    </div>
  );
};

export default HaversineCalculator;